import { t } from 'i18next';
import { MainLayout } from '../../Layout/MainLayout';
import { MainBreadcrumbs } from '../../Layout/MainBreadcrumbs';
import {
  AccountListItemButton,
  Button,
  ContentIsland,
  ErrorListItem,
  Grid,
  ListContentIsland,
  ListItem,
  Money,
  Skeleton,
  SkeletonListItem,
  Stack,
  Typography,
} from '@razz-team/ui-web';
import { useCardQuery } from '../../../api/cards';
import { Route } from '../../../routes/account.cards_.$cardId';
import { Card } from '../CreateCardPage/Card';
import { useAccountQuery } from '../../../api/accounts';
import { CardSpendingLimitView } from './CardSpendingLimitView';
import { CardActionsView } from './CardActionsView';
import { useHasRole } from '../../../api/access';
import { LastTransactions } from '../AccountPage/LastTransactions';

export function CardPage() {
  const { cardId } = Route.useParams();
  const isAdmin = useHasRole('ADMIN');
  const cardQuery = useCardQuery({ cardId });
  const accountQuery = useAccountQuery({ accountId: cardQuery.data?.spendingStrategy.accountId });
  const card = cardQuery.data;

  return (
    <MainLayout
      compact
      title={
        <MainBreadcrumbs
          title={cardQuery.data?.name}
          loading={cardQuery.isPending}
          parent={{
            to: '/account/home',
            title: t('Home'),
          }}
        />
      }
    >
      <Grid size={12}>
        <ContentIsland sx={{ padding: 4 }}>
          <Stack spacing={8}>
            <Stack justifyContent="space-between" direction="row" spacing={2}>
              <Stack direction="column" spacing={0.5}>
                <Typography variant="h2">
                  {card?.name ?? <Skeleton variant="text" width={100} />}
                </Typography>
                <Typography variant="subtitle2" color="GrayText">
                  {card?.cardHolderName ?? <Skeleton />}
                </Typography>
              </Stack>
              {card?.status === 'ACTIVE' ? (
                <Stack direction="column" spacing={0.5} alignItems="flex-end">
                  <Money variant="h2" value={card?.availableAmount} loading={cardQuery.isPending} />
                  <Typography variant="subtitle2" color="GrayText">
                    {t('Available')}
                  </Typography>
                </Stack>
              ) : null}
            </Stack>
            {card?.status === 'ACTIVE' && card?.spendingLimitPolicy ? (
              <CardSpendingLimitView card={card} />
            ) : null}
            <Stack alignItems="center">
              <Card
                status={card?.status}
                cardDesign={card?.cardDesign}
                holderName={card?.cardHolderName}
              />
            </Stack>
            <CardActionsView card={card} isAdmin={isAdmin} />
          </Stack>
        </ContentIsland>
      </Grid>
      <Grid size={{ md: 6, xs: 12 }}>
        <ListContentIsland
          title={t('Account')}
          actions={
            isAdmin ? (
              <Button variant="text" href={`/account/cards/${cardId}/account`}>
                {t('Change')}
              </Button>
            ) : null
          }
        >
          {accountQuery.data ? (
            <ListItem disablePadding>
              <AccountListItemButton<'a'>
                account={accountQuery.data}
                href={`/account/${accountQuery.data.id}`}
              />
            </ListItem>
          ) : accountQuery.isError ? (
            <ErrorListItem error={accountQuery.error} />
          ) : (
            <SkeletonListItem variant="withButton" />
          )}
        </ListContentIsland>
      </Grid>
      <Grid size={{ md: 6, xs: 12 }}>
        <LastTransactions cardId={cardId} />
      </Grid>
    </MainLayout>
  );
}
